import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCommonModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';

import { TranslateModule } from '@ngx-translate/core';

import { MgFormFieldModule } from '../form-field/MgFormField.module';
import { MgIconModule } from '../icon/MgIcon.module';
import { CustomDatePickerHeader } from './CustomDatePickerHeader.component';
import { DateTimePickerComponent } from './DateTimePicker.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgFormFieldModule,
    MgIconModule,

    // External dependencies
    FormsModule,
    CommonModule,
    MatCommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
  ],
  declarations: [DateTimePickerComponent, CustomDatePickerHeader],
  exports: [DateTimePickerComponent, CustomDatePickerHeader],
})
export class MgDateTimePickerModule {}
